import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isNil from 'utils/isNil';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import Button from 'components/Core/Button';
import SubscribeForm from 'components/Form/SubscribeForm';
import Text from 'components/Core/Text';
import { SectionTryDemo, FormContainer } from './styles';

const InlineCta = props => {
  const {
    dataPosition,
    formType,
    subHead,
    title,
    colorScheme,
    buttonTitle,
    buttonLinkTo,
    utm,
    useModalForm,
    modalForm,
    ...otherProps
  } = props;
  const [search, setSearch] = useState(undefined);
  const [isModalOpen, toggleIsModalOpen] = useState(false);

  useEffect(() => {
    setSearch(window?.location?.search);
  }, []);

  return (
    <SectionTryDemo
      backgroundColor={colorScheme?.includes('Blue') ? '#009DE6' : '#12889D'}
      titleColor="white"
      {...otherProps}
    >
      <div className="section-try-demo--container">
        <div className="section-try-demo--text-container">
          {!isNil(subHead) && <p className="section-try-demo--small-title">{subHead}</p>}
          <Text type="p" size="h2" className="section-try-demo--title">
            {title}
          </Text>
        </div>

        {(useModalForm || buttonLinkTo) && (
          <div className="section-try-demo--button-container">
            <Button
              dataPosition="Body Conversion Panel - Split CTA"
              type={colorScheme?.includes('White') ? 'white' : 'primary'}
              shadow={false}
              {...(buttonLinkTo ? { to: `${buttonLinkTo}${utm && search ? search : ''}` } : {})}
              {...(useModalForm ? { onClick: () => toggleIsModalOpen(true) } : {})}
            >
              {buttonTitle}
            </Button>
          </div>
        )}
        {!useModalForm && modalForm && (
          <FormContainer>
            <SubscribeForm
              dataPosition={dataPosition}
              inlineMarketingForm={modalForm}
              buttonLabel={buttonTitle}
              buttonType="primary"
              notificationMessage={modalForm.thankyou || 'Thanks for subscribing!'}
              notificationSnack={modalForm.thankyouSnackbar}
              shouldRedirect={false}
              shadow={false}
              label=""
            />
          </FormContainer>
        )}
      </div>
      {useModalForm && (
        <ModalMarketingForm
          dataPosition={dataPosition}
          formType={formType}
          isModalOpen={isModalOpen}
          onModalCancel={() => toggleIsModalOpen(false)}
          inlineMarketingForm={modalForm}
          onFormSuccess={() => toggleIsModalOpen(false)}
        />
      )}
    </SectionTryDemo>
  );
};

InlineCta.propTypes = {
  subHead: PropTypes.string,
  title: PropTypes.string,
  backgroundColor: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonLinkTo: PropTypes.string,
};

export default InlineCta;
